// extracted by mini-css-extract-plugin
export default {"comment":"NftTransactionComment_comment__9rEsa"};